<template>
  <div class="bee-guide">
    <!-- 引导主面板 -->
    <transition name="bee-fade">
      <div class="bee-guide-mask" v-if="showPanel" @click.self="minimize">
        <transition name="bee-pop">
          <div class="bee-guide-panel" v-if="showPanel">
            <!-- 顶部进度 -->
            <div class="bee-progress">
              <div class="bee-progress-title">
                <i class="el-icon-guide"></i>
                <span>新手引导 · 上课全流程</span>
              </div>
              <div class="bee-progress-steps">
                <span
                  v-for="(s, i) in steps"
                  :key="i"
                  class="dot"
                  :class="{ active: i === current, done: i < current }"
                  @click="goto(i)"
                ></span>
              </div>
            </div>

            <!-- 云朵气泡 + 蜜蜂 -->
            <div class="bee-body">
              <div class="bee-avatar">
                <img :src="beeGif" alt="小狐狸" class="bee-img" />
              </div>
              <div class="bee-cloud">
                <div class="bee-cloud-tag">
                  <span class="step-index">STEP {{ current + 1 }}</span>
                  <span class="step-name">{{ steps[current].title }}</span>
                </div>
                <div class="bee-cloud-text">
                  <p class="typed">{{ typedText }}<span class="caret" v-if="typing">|</span></p>
                </div>
                <ul class="bee-cloud-tips" v-if="!typing && steps[current].tips && steps[current].tips.length">
                  <li v-for="(tip, ti) in steps[current].tips" :key="ti">
                    <i class="el-icon-caret-right"></i>{{ tip }}
                  </li>
                </ul>
                <!-- 云朵尾巴 -->
                <span class="cloud-bubble b1"></span>
                <span class="cloud-bubble b2"></span>
                <span class="cloud-bubble b3"></span>
              </div>
            </div>

            <!-- 底部操作 -->
            <div class="bee-footer">
              <el-button
                size="small"
                type="text"
                icon="el-icon-download"
                class="manual-btn"
                @click="downloadManual"
              >下载操作手册</el-button>
              <div class="bee-btns">
                <el-button size="small" plain @click="skip">跳过引导</el-button>
                <el-button size="small" :disabled="current === 0" @click="prev">上一步</el-button>
                <el-button
                  size="small"
                  type="primary"
                  @click="next"
                >{{ current === steps.length - 1 ? '完成' : '下一步' }}</el-button>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </transition>

    <!-- 悬浮唤起按钮（面板收起时显示） -->
    <transition name="bee-fab">
      <div class="bee-fab" v-if="!showPanel" @click="open" title="点我看操作指导">
        <img :src="beeGif" alt="小狐狸" class="bee-fab-img" />
        <div class="bee-fab-tip">操作<br />指导</div>
      </div>
    </transition>
  </div>
</template>

<script>
const STORE_KEY = 'teacher_bee_guide_done'

export default {
  name: 'beeGuide',
  data() {
    return {
      beeGif: require('@/assets/images/teacher/狐狸.gif'),
      showPanel: false,
      current: 0,
      typedText: '',
      typing: false,
      typeTimer: null,
      steps: [
        {
          title: '欢迎使用',
          text: '你好呀，我是小狐狸助教！第一次来的老师别担心，点击下一步跟着我一步步走，就能顺利给学生上课啦～',
          tips: [
            '整个流程：进入班级 → 分组 → 上课 → 看成绩 → 下课 → 兑奖',
            '随时可以点左下角的小狐狸再次唤起我'
          ]
        },
        {
          title: '进入班级',
          text: '第一步，点左侧「我的班级」，切到「临时班级（已安排集训）」，找到进行中的班级，点右侧「进入班级」。',
          tips: [
            '只有集训状态为「进行中」的班级才能进入上课',
            '找不到班级？用上方搜索框输入班级名称查询'
          ]
        },
        {
          title: '分组管理',
          text: '进入班级后切到「分组管理」标签。点右上角「学生随机分组」，填写小组个数即可自动均分。',
          tips: [
            '想指定人数/成员：改用「创建小组」',
            '已有小组可点「编辑小组」修改名称和成员',
            '上课前必须先分好组，否则无法上课'
          ]
        },
        {
          title: '开始上课',
          text: '分好组后切到「课程安排」标签，右上角会出现「上课」按钮，点击即可开始上课。',
          tips: [
            '⚠️ 一天只能点一次上课和一次下课，请谨慎操作',
            '上课前请确认学生平板显示「已连接」'
          ]
        },
        {
          title: '查看成绩',
          text: '上课后到左侧「数据中心 → 成绩数据」，找到班级点「分屏显示」，就能实时看各小组的答题成绩排名。',
          tips: [
            '双击可分屏显示，小组成绩下拉查看完整名单',
            '用「移除缺勤」开关可剔除没来的学生'
          ]
        },
        {
          title: '下课与兑奖',
          text: '课程结束回到「课程安排」点「下课」。随后点「开始兑换」，学生就能在平板上用金币发起兑换啦。',
          tips: [
            '学生兑换后，到「兑换中心 → 兑换审核」审批',
            '可勾选多条记录「批量审核」，高效发放礼品'
          ]
        },
        {
          title: '大功告成',
          text: '太棒了！你已经掌握完整的上课流程～ 以后遇到不清楚的，随时点左下角的小狐狸，我都在哦！',
          tips: [
            '祝你上课顺利，狐狸随时待命 🐝'
          ]
        }
      ]
    }
  },
  mounted() {
    // 本次会话首次进入教师端自动弹出引导，弹过后刷新不再自动弹
    if (!sessionStorage.getItem(STORE_KEY)) {
      sessionStorage.setItem(STORE_KEY, '1')
      this.open()
    }
    // 允许外部通过事件总线唤起
    this.$Bus.$on('open_bee_guide', this.open)
  },
  beforeDestroy() {
    this.stopTyping()
    this.$Bus.$off('open_bee_guide', this.open)
  },
  methods: {
    open() {
      this.showPanel = true
      this.current = 0
      this.startTyping()
    },
    minimize() {
      this.showPanel = false
      this.stopTyping()
    },
    goto(i) {
      if (i === this.current) return
      this.current = i
      this.startTyping()
    },
    next() {
      if (this.typing) {
        // 正在打字时点击直接显示全文
        this.finishTyping()
        return
      }
      if (this.current === this.steps.length - 1) {
        this.minimize()
        return
      }
      this.current++
      this.startTyping()
    },
    prev() {
      if (this.current === 0) return
      this.current--
      this.startTyping()
    },
    skip() {
      this.minimize()
    },
    downloadManual() {
      const fileName = '教师端操作手册.docx'
      const a = document.createElement('a')
      a.href = process.env.BASE_URL + encodeURIComponent(fileName)
      a.download = fileName
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    // ---------- 打字机效果 ----------
    startTyping() {
      this.stopTyping()
      const full = this.steps[this.current].text
      this.typedText = ''
      this.typing = true
      let idx = 0
      this.typeTimer = setInterval(() => {
        this.typedText += full.charAt(idx)
        idx++
        if (idx >= full.length) {
          this.finishTyping()
        }
      }, 45)
    },
    finishTyping() {
      this.stopTyping()
      this.typedText = this.steps[this.current].text
      this.typing = false
    },
    stopTyping() {
      if (this.typeTimer) {
        clearInterval(this.typeTimer)
        this.typeTimer = null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$bee-primary: #ffb300;
$bee-primary-deep: #ff8f00;
$bee-blue: #409eff;

.bee-guide {
  position: relative;
  z-index: 3000;
}

/* ---------- 遮罩 ---------- */
.bee-guide-mask {
  position: fixed;
  inset: 0;
  background: rgba(30, 42, 68, 0.45);
  backdrop-filter: blur(2px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3000;
}

/* ---------- 主面板 ---------- */
.bee-guide-panel {
  width: 560px;
  max-width: 92vw;
  background: linear-gradient(180deg, #eaf4ff 0%, #ffffff 42%);
  border-radius: 22px;
  box-shadow: 0 24px 70px rgba(30, 60, 120, 0.28);
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.9);
}

/* 顶部进度条 */
.bee-progress {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 22px;
  background: linear-gradient(135deg, #ffd54f, $bee-primary);

  .bee-progress-title {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #6d4c00;
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 0.5px;

    i {
      font-size: 18px;
    }
  }

  .bee-progress-steps {
    display: flex;
    align-items: center;
    gap: 8px;

    .dot {
      width: 9px;
      height: 9px;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.55);
      cursor: pointer;
      transition: all 0.25s;

      &.done {
        background: #fff;
      }

      &.active {
        width: 22px;
        border-radius: 5px;
        background: #fff;
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
      }
    }
  }
}

/* 主体：蜜蜂 + 云朵 */
.bee-body {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  padding: 26px 24px 10px;
}

.bee-avatar {
  flex-shrink: 0;
  width: 108px;
  height: 108px;
  display: flex;
  align-items: center;
  justify-content: center;

  .bee-img {
    width: 108px;
    height: 108px;
    object-fit: contain;
    animation: bee-float 2.4s ease-in-out infinite;
    filter: drop-shadow(0 8px 12px rgba(255, 143, 0, 0.25));
  }
}

//@keyframes bee-float {
//  0%, 100% { transform: scaleX(-1) translateY(0) rotate(-2deg); }
//  50% { transform: scaleX(-1) translateY(-10px) rotate(2deg); }
//}
@keyframes bee-float {
  0%, 100% { transform: scaleX(-1.3) translateX(0) rotate(2deg); }
  50% { transform: scaleX(-1.3) translateX(8px) rotate(2deg); }
}

/* 云朵气泡 */
.bee-cloud {
  position: relative;
  flex: 1;
  background: #fff;
  border-radius: 20px;
  padding: 16px 20px 18px;
  box-shadow: 0 8px 26px rgba(64, 130, 220, 0.14);
  border: 1.5px solid #eef4ff;
  min-height: 120px;

  /* 云朵指向蜜蜂的小尾巴 */
  .cloud-bubble {
    position: absolute;
    background: #fff;
    border-radius: 50%;
    border: 1.5px solid #eef4ff;
    left: -8px;
  }
  .b1 { width: 16px; height: 16px; top: 30px; }
  .b2 { width: 10px; height: 10px; top: 50px; left: -16px; }
  .b3 { width: 6px; height: 6px; top: 66px; left: -24px; }

  .bee-cloud-tag {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 10px;

    .step-index {
      font-size: 12px;
      font-weight: 700;
      color: #fff;
      background: linear-gradient(135deg, $bee-primary, $bee-primary-deep);
      padding: 3px 10px;
      border-radius: 20px;
      letter-spacing: 0.5px;
    }

    .step-name {
      font-size: 16px;
      font-weight: 700;
      color: #2b3a55;
    }
  }

  .bee-cloud-text {
    .typed {
      margin: 0;
      font-size: 14.5px;
      line-height: 1.75;
      color: #46566f;
      min-height: 24px;

      .caret {
        color: $bee-primary;
        font-weight: 700;
        animation: bee-caret 0.8s step-end infinite;
      }
    }
  }

  .bee-cloud-tips {
    list-style: none;
    margin: 12px 0 0;
    padding: 12px 14px;
    background: linear-gradient(135deg, #fff8e6, #fffdf5);
    border-radius: 12px;
    border: 1px dashed #ffe0a3;

    li {
      font-size: 13px;
      line-height: 1.9;
      color: #8a6d2f;
      display: flex;
      align-items: flex-start;
      gap: 4px;

      i {
        color: $bee-primary;
        margin-top: 4px;
      }
    }
  }
}

@keyframes bee-caret {
  50% { opacity: 0; }
}

/* 底部操作 */
.bee-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 24px 20px;

  .manual-btn {
    color: $bee-primary-deep;
    font-weight: 600;

    &:hover {
      color: $bee-primary;
    }
  }

  .bee-btns {
    display: flex;
    gap: 10px;

    ::v-deep .el-button--primary {
      background: linear-gradient(135deg, $bee-primary, $bee-primary-deep);
      border: none;

      &:hover {
        background: linear-gradient(135deg, #ffc233, $bee-primary);
      }
    }
  }
}

/* ---------- 悬浮唤起按钮 ---------- */
.bee-fab {
  position: fixed;
  left: 26px;
  bottom: 30px;
  z-index: 2999;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: transform 0.25s;

  &:hover {
    transform: scale(1.08);

    .bee-fab-tip {
      opacity: 1;
    }
  }

  .bee-fab-img {
    width: 72px;
    height: 72px;
    object-fit: contain;
    animation: bee-float 2.4s ease-in-out infinite;
    filter: drop-shadow(0 6px 10px rgba(255, 143, 0, 0.3));
  }

  .bee-fab-tip {
    margin-top: -6px;
    margin-right: 10px;
    font-size: 12px;
    font-weight: 700;
    color: #fff;
    background: linear-gradient(135deg, $bee-primary, $bee-primary-deep);
    padding: 4px 10px;
    border-radius: 12px;
    line-height: 1.2;
    text-align: center;
    box-shadow: 0 4px 12px rgba(255, 143, 0, 0.35);
    opacity: 0.92;
    transition: opacity 0.25s;
  }
}

/* ---------- 过渡动画 ---------- */
.bee-fade-enter-active, .bee-fade-leave-active { transition: opacity 0.3s; }
.bee-fade-enter, .bee-fade-leave-to { opacity: 0; }

.bee-pop-enter-active { transition: all 0.38s cubic-bezier(0.34, 1.56, 0.64, 1); }
.bee-pop-leave-active { transition: all 0.25s; }
.bee-pop-enter { opacity: 0; transform: translateY(30px) scale(0.92); }
.bee-pop-leave-to { opacity: 0; transform: scale(0.96); }

.bee-fab-enter-active { transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1); }
.bee-fab-leave-active { transition: all 0.2s; }
.bee-fab-enter { opacity: 0; transform: translateY(40px) scale(0.5); }
.bee-fab-leave-to { opacity: 0; transform: scale(0.5); }
</style>
